export const useAnalytics = () => {
  const trackEvent = (eventName: string, parameters: Record<string, any> = {}) => {
    // Track with gtag (Google Analytics 4) - nuxt-gtag handles this automatically
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, parameters)
    }
  }

  const trackSignup = () => {
    trackEvent('toolbox_signup', {
      event_label: 'Toolbox Signup',
      event_category: 'toolbox_signup',
    })
  }

  const trackSignupActivation = () => {
    trackEvent('toolbox_signup_activation', {
      event_label: 'Toolbox Signup Activation',
      event_category: 'toolbox_signup_activation',
      currency: 'GBP',
      value: 10.00,
    })
  }

  const trackSearch = (searchTerm: string) => {
    trackEvent('search', {
      search_term: searchTerm,
    })
  }

  return {
    trackEvent,
    trackSignup,
    trackSignupActivation,
    trackSearch
  }
} 